import * as React from "react"
import { Flex, SimpleGrid } from "@chakra-ui/react"
import {
  FacebookButton,
  TwitterButton,
  LinkedinButton,
  MailButton,
  RedditButton,
  PinterestButton
} from "../../common/buttons/social-media-buttons"
import { useLocalUserType } from "../../../hooks/useLocalUserType"
import { roomLinksSelector } from "../../../recoil/atoms/roomLinks"
import { useRecoilValue } from "recoil"
import { localUserIdAtom, usersSelector } from "../../../recoil/atoms/users"
import { brandingSelector } from "../../../recoil/atoms/room"
import MOLocation from "../../../util/MOLocation"
import useOnClickWithTouchHandler from "../../../hooks/useOnClickWithTouchHandler"

const _ShareSocialMedia = ({ isMobile }) => {
  const { isAudience } = useLocalUserType()
  const { audienceHash } = useRecoilValue(roomLinksSelector)
  const localUserId = useRecoilValue(localUserIdAtom)
  const localUser = useRecoilValue(usersSelector(localUserId))
  const roomStyles = useRecoilValue(brandingSelector)
  const currentUrl = MOLocation.getLocation().origin

  const encodedUrl = encodeURIComponent(
    isAudience
      ? MOLocation.getLocation().href.split("?")[0]
      : `${currentUrl}/${audienceHash}`
  )

  const shareOnLinkedin = () => {
    const encodedTitle = encodeURIComponent(
      "Come and join me in a live online event!"
    )
    const sharedUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`
    window.open(sharedUrl, "_blank")
  }

  const handleOnTwitter = () => {
    const encodedText = encodeURIComponent(
      `Come and join me in a live online event!`
    )

    const sharedUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`
    window.open(sharedUrl, "_blank")
  }

  const handleOnFacebook = () => {
    const sharedUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
    window.open(sharedUrl, "_blank")
  }

  const handleOnMail = () => {
    const title = "Join me"
    const description = `Come and join me in a live online event! ${
      isAudience
        ? MOLocation.getLocation().href.split("?")[0]
        : `${currentUrl}/${audienceHash}`
    }`
    const mailtoUrl = `mailto:?subject=${encodeURIComponent(
      title
    )}&body=${encodeURIComponent(description)}`

    window.open(mailtoUrl, "_blank")
  }

  const handleOnReddit = () => {
    const baseUrl = "https://www.reddit.com/submit"
    const title = "Join me"
    const encodedTitle = encodeURIComponent(title)
    const sharedUrl = `${baseUrl}?url=${encodedUrl}&title=${encodedTitle}`
    window.open(sharedUrl, "_blank")
  }

  const handleOnPinterest = () => {
    const baseUrl = "https://www.pinterest.com/pin/create/button/"
    const encodedImageUrl = encodeURIComponent(roomStyles?.roomHeaderIcon)
    const description = encodeURIComponent(
      `You've been invited to an online event by ${localUser?.name}. To join them, click here: ${encodedUrl}`
    )
    const sharedUrl = `${baseUrl}?url=${encodedUrl}&media=${encodedImageUrl}&description=${description}`
    window.open(sharedUrl, "_blank")
  }

  const facebookHandler = useOnClickWithTouchHandler(handleOnFacebook)
  const twitterHandler = useOnClickWithTouchHandler(handleOnTwitter)
  const linkedinHandler = useOnClickWithTouchHandler(shareOnLinkedin)
  const pinterestHandler = useOnClickWithTouchHandler(handleOnPinterest)
  const redditHandler = useOnClickWithTouchHandler(handleOnReddit)
  const mailHandler = useOnClickWithTouchHandler(handleOnMail)

  if (!isMobile) {
    return (
      <Flex justifyContent="center" flexDirection="column">
        <Flex>
          <FacebookButton onClick={handleOnFacebook} marginRight={"1rem"} />
          <TwitterButton onClick={handleOnTwitter} marginRight={"1rem"} />
          <LinkedinButton onClick={shareOnLinkedin} />
        </Flex>
        <Flex justifyContent="center">
          <PinterestButton onClick={handleOnPinterest} marginRight={"1rem"} />
          <RedditButton onClick={handleOnReddit} marginRight={"1rem"} />
          <MailButton onClick={handleOnMail} />
        </Flex>
      </Flex>
    )
  }

  return (
    <SimpleGrid columns={6} spacing={2} marginTop="1rem">
      <SocialMediaIcon Component={FacebookButton} {...facebookHandler} />
      <SocialMediaIcon Component={TwitterButton} {...twitterHandler} />
      <SocialMediaIcon Component={LinkedinButton} {...linkedinHandler} />

      <SocialMediaIcon Component={PinterestButton} {...pinterestHandler} />
      <SocialMediaIcon Component={RedditButton} {...redditHandler} />
      <SocialMediaIcon Component={MailButton} {...mailHandler} />
    </SimpleGrid>
  )
}

const SocialMediaIcon = ({ Component, ...props }) => (
  <Component
    onlyIcon={true}
    marginX={"0.2rem"}
    alignSelf="center"
    justifySelf="center"
    height={"2.3rem"}
    width={"2.3rem"}
    minWidth={"2.3rem"}
    // borderRadius={100}
    padding={"0px"}
    {...props}
  />
)

export const ShareSocialMedia = React.memo(_ShareSocialMedia)
